import styled, { css } from 'styled-components';

export const FiltersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
`;

export const SortingWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 24px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  > div:last-child {
    height: 48px;
  }
`;

const gridTableCol = css`
  --padding-inline: 32px;

  display: grid;
  grid-template-columns: 1fr 3fr 2fr repeat(5, 1fr);
  column-gap: 24px;
  padding-inline: var(--padding-inline);
`;

export const Legend = styled.div`
  ${gridTableCol}
  margin-bottom: 16px;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }

  > *:last-child {
    margin-right: calc(var(--padding-inline) * -1);
  }
`;

export const ActivityCard = styled.div`
  ${gridTableCol}
  align-items: center;
  height: 73px;
  margin-bottom: 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  .b2 {
    line-height: 1;
  }
`;

export const Column = styled.div.withConfig({
  shouldForwardProp: (prop) => !['rowGap'].includes(prop),
})`
  display: flex;
  flex-direction: column;
  row-gap: ${({ rowGap }) => rowGap}px;
`;
